import { dashboardConstants } from "./constants";
const initialState = {
  dataList: [],
  data: null,
  contList: [],
  gestionList: [],
  gestionFilters: {},
  actuacionesList: [],
  actuacion: null,
  inmueblesList: [],
  inmueble: null,
  deuda: null,
  abogadosList: [],
  abogado: null,
  convenios: [],
  convenio: null,
  condlegalesList: [],
  condlegal: null,
  planesList: [],
  planpago: [],
  deuda_planpago: [],
  planData: {},
  legalpp: {},
  tipoDoc: [],
  grupoEtapas: [],
  tipoEtapas: [],
  convEstados: [],
  convCaracter: [],
  convFormaPago: [],
  showTable: false,

  loading: false,
  error: false,
  success: false,
  errorMessage: "",
};

export const dashboard = (state = initialState, action) => {
  switch (action.type) {
  case dashboardConstants.FETCH_STARTED:
    return {
      ...state,
      ...action.payload,
      loading: true,
      error: false,
      success: false,
    };
  case dashboardConstants.FETCH_ERROR:
    return {
      ...state,
      data: null,
      dataList: [],
      gestionList: [],
      inmueblesList: [],
      contList: [],
      actuacionesList: [],
      convenios: [],
      planesList: [],
      loading: false,
      error: true,
      errorMessage: action.payload,
    };
  case dashboardConstants.FETCH_SUCCESS:
    return {
      ...state,
      loading: false,
      error: false,
      success: true,
    };
  case dashboardConstants.SET_DATA_LIST:
    return {
      ...state,
      loading: false,
      dataList: action.payload,
    };
  case dashboardConstants.SET_DATA:
    return {
      ...state,
      loading: false,
      data: action.payload,
    };
  case dashboardConstants.SET_CONT_LIST:
    return {
      ...state,
      loading: false,
      contList: action.payload,
    };
  case dashboardConstants.SET_CONTRIBUYENTE:
    return {
      ...state,
      loading: false,
      contribuyente: action.payload,
    };
  case dashboardConstants.SET_INMUEBLES_LIST:
    return {
      ...state,
      loading: false,
      inmueblesList: action.payload,
    };
  case dashboardConstants.SET_INMUEBLE:
    return {
      ...state,
      loading: false,
      inmueble: action.payload,
    };
  case dashboardConstants.SET_DEUDA:
    return {
      ...state,
      loading: false,
      deuda: action.payload,
    };
  case dashboardConstants.CLEAR_DEUDA:
    return {
      ...state,
      deuda: null,
    };
  case dashboardConstants.SET_ABOGADOS_LIST:
    return {
      ...state,
      loading: false,
      abogadosList: action.payload,
    };
  case dashboardConstants.SET_ABOGADO:
    return {
      ...state,
      loading: false,
      abogado: action.payload,
    };
  case dashboardConstants.SET_GESTION_LIST:
    return {
      ...state,
      loading: false,
      gestionList: action.payload.data,
      gestionFilters: action.payload.filters,
    };
  case dashboardConstants.SET_ACTUACION_LIST:
    return {
      ...state,
      loading: false,
      actuacionesList: action.payload,
    };
  case dashboardConstants.SET_ACTUACION:
    return {
      ...state,
      loading: false,
      actuacion: action.payload,
    };
  case dashboardConstants.SET_CONVENIO_LIST:
    return {
      ...state,
      loading: false,
      convenios: action.payload,
    };
  case dashboardConstants.SET_CONVENIO:
    return {
      ...state,
      loading: false,
      convenio: action.payload,
    };
  case dashboardConstants.SET_COND_LEG_LIST:
    return {
      ...state,
      loading: false,
      condlegalesList: action.payload,
    };
  case dashboardConstants.SET_COND_LEG:
    return {
      ...state,
      loading: false,
      condlegal: action.payload,
    };
  case dashboardConstants.SET_PLANES_LIST:
    return {
      ...state,
      loading: false,
      planesList: action.payload,
    };
  case dashboardConstants.SET_PLAN:
    return {
      ...state,
      loading: false,
      deuda_planpago: action.payload,
    };
  case dashboardConstants.SET_PLAN_PAGO:
    return {
      ...state,
      loading: false,
      planpago: action.payload,
    };
  case dashboardConstants.SET_PLANES_DATA:
    return {
      ...state,
      loading: false,
      planData: action.payload,
    };
  case dashboardConstants.SET_LEGAL_PLANES:
    return {
      ...state,
      loading: false,
      legalpp: action.payload,
    };
  case dashboardConstants.TIPO_DOCUMENTO:
    return {
      ...state,
      loading: false,
      tipoDoc: action.payload,
    };
  case dashboardConstants.SET_GRUPO_ETAPAS:
    return {
      ...state,
      loading: false,
      grupoEtapas: action.payload,
    };
  case dashboardConstants.SET_TIPO_ETAPAS:
    return {
      ...state,
      loading: false,
      tipoEtapas: action.payload,
    };
  case dashboardConstants.SET_TIPO_RETIRO:
    return {
      ...state,
      loading: false,
      tiposRetiro: action.payload,
    };
  case dashboardConstants.SET_CONV_ESTADO:
    return {
      ...state,
      loading: false,
      convEstados: action.payload,
    };
  case dashboardConstants.CONV_CARACTER:
    return {
      ...state,
      loading: false,
      convCaracter: action.payload,
    };
  case dashboardConstants.CONV_FORMAPAGOS:
    return {
      ...state,
      loading: false,
      convFormaPago: action.payload,
    };
  case dashboardConstants.SET_LOADING:
    return {
      ...state,
      loading: action.payload,
    };
  case dashboardConstants.SHOW_TABLE:
    return {
      ...state,
      showTable: true,
    };
  case dashboardConstants.CLEAR_INMUEBLES_LIST:
    return {
      ...state,
      inmueblesList: [],
    };
  case dashboardConstants.CLEAR:
    return state = initialState;
  case dashboardConstants.SET_COMERCIOS_LIST:
    return {
      ...state,
      comerciosList: action.payload,
      loading: false,
    };
  case dashboardConstants.SET_IMPONIBLES:
    return {
      ...state,
      imponibles: action.payload,
    };
  default:
    return state;
  }
};